import { render, staticRenderFns } from "./PlusProductValueBase.vue?vue&type=template&id=1cb998a2&scoped=true"
import script from "./PlusProductValueBase.vue?vue&type=script&lang=ts"
export * from "./PlusProductValueBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb998a2",
  null
  
)

export default component.exports